import '../App.css';
import theGraphLogo from '../images/thegraph/thegraph-email-logo.png';

function TheGraph() {
  return (
    <div className="project-page">
      <div className="project-hero">
        <a href="https://thegraph.com" target="_blank" rel="noopener noreferrer">
          <img className="project-hero-logo" src={theGraphLogo} alt="The Graph" />
        </a>
        <p className="project-hero-tagline">counterpoint are very proud to be participating as an indexer in The Graph network</p>
      </div>

      <div className="project-content container">

        <div className="project-card">
          <h3 className="project-card-title">Achievements</h3>
          <ul className="project-list">
            <li>2020–2021 Ran DevOps for an indexing team in Mission Control (the incentivised testnet)</li>
            <li>2022-09-20 Joined the MIPS program to become a fully fledged indexer</li>
            <li>2022-09-25 Testnet indexer <a href="https://testnet.thegraph.com/explorer/profile/0x75aea8ac91ce8c60430d5e6d399c7a29c52f6574?view=Indexing">counterpoint-indexer.eth</a> created on Goerli</li>
            <li>2022-10-20 Mainnet indexer <a href="https://thegraph.com/explorer/profile?id=0x745cf2b4e7a5b2f25112d9cea19d914da6d33844&view=Indexing">counterpoint-indexer.eth</a> created on Ethereum mainnet</li>
            <li>2022-12-24 Allocated first stake on mainnet</li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default TheGraph;
